import { ReactComponent as Busca } from './svg/Busca.svg';
import { ReactComponent as Close } from './svg/Close.svg';
import { ReactComponent as LightClose } from './svg/LightClose.svg';
import { ReactComponent as WhiteLightClose } from './svg/WhiteLightClose.svg';
import { ReactComponent as Menu } from './svg/Menu.svg';
import { ReactComponent as People } from './svg/People.svg';
import { ReactComponent as Facebook } from './svg/Facebook.svg';
import { ReactComponent as Instagram } from './svg/Instagram.svg';
import { ReactComponent as Twitter } from './svg/Twitter.svg';
import { ReactComponent as Youtube } from './svg/Youtube.svg';
import { ReactComponent as Whatsapp } from './svg/Whatsapp.svg';
import { ReactComponent as Telegram } from './svg/Telegram.svg';
import { ReactComponent as TikTok } from './svg/TikTok.svg';
import { ReactComponent as Linkedin } from './svg/Linkedin.svg';
import { ReactComponent as ChevronRight } from './svg/ChevronRight.svg';
import { ReactComponent as Play } from './svg/Play.svg';
import { ReactComponent as PlayRounded } from './svg/PlayRounded.svg';
import { ReactComponent as Update } from './svg/Update.svg';
import { ReactComponent as Warning } from './svg/Warning.svg';
import { ReactComponent as Quote } from './svg/Quote.svg';
import { ReactComponent as ArrowLeft } from './svg/ArrowLeft.svg';
import { ReactComponent as ArrowRight } from './svg/ArrowRight.svg';
import { ReactComponent as ArrowDown } from './svg/ArrowDown.svg';
import { ReactComponent as ArrowUp } from './svg/ArrowUp.svg';
import { ReactComponent as Email } from './svg/Email.svg';
import { ReactComponent as Pause } from './svg/Pause.svg';
import { ReactComponent as Replay } from './svg/Replay.svg';
import { ReactComponent as Share } from './svg/Share.svg';
import { ReactComponent as Minus } from './svg/Minus.svg';
import { ReactComponent as More } from './svg/More.svg';
import { ReactComponent as Pix } from './svg/Pix.svg';
import { ReactComponent as CreditCard } from './svg/CreditCard.svg';
import { ReactComponent as InfoTooltip } from './svg/InfoTooltip.svg';
import styled, { css } from 'styled-components';

const Icon = ({ name, color, ...props }) => {
    let colored = color || '#000';
    switch (name) {
        case 'Busca':
            return <Busca stroke={colored} {...props} />;
        case 'Close':
            return <Close stroke={colored} {...props} />;
        case 'LightClose':
            return <LightClose stroke={colored} {...props} />;
        case 'WhiteLightClose':
            return <WhiteLightClose stroke={colored} {...props} />;
        case 'Menu':
            return <Menu stroke={colored} {...props} />;
        case 'PlayRounded':
            return <PlayRounded fill={colored} {...props} />;
        case 'Update':
            return <Update fill={colored} {...props} />;
        case 'Quote':
            return <Quote {...props} />;
        case 'ArrowLeft':
            return <ArrowLeft stroke={colored} {...props} />;
        case 'ArrowRight':
            return <ArrowRight stroke={colored} {...props} />;
        case 'ArrowRightMini':
            return <ArrowRight stroke={colored} width={8} height={16} strokeWidth={4} {...props} />;
        case 'ArrowDown':
            return <ArrowDown stroke={colored} {...props} />;
        case 'ArrowUp':
            return <ArrowUp stroke={colored} {...props} />;
        case 'Minus':
            return <Minus stroke={colored} {...props} />;
        case 'More':
            return <More stroke={colored} {...props} />;
        case 'Share':
            return (
                <Wrapper color={colored}>
                    <Share stroke={colored} {...props} />
                </Wrapper>
            );
        case 'People':
            return (
                <Wrapper color={colored}>
                    <People fill={colored} {...props} />
                </Wrapper>
            );
        case 'Facebook':
            return (
                <Wrapper color={colored}>
                    <Facebook fill={colored} {...props} />
                </Wrapper>
            );
        case 'Instagram':
            return (
                <Wrapper color={colored}>
                    <Instagram fill={colored} {...props} />
                </Wrapper>
            );
        case 'Twitter':
            return (
                <Wrapper color={colored}>
                    <Twitter fill={colored} {...props} />
                </Wrapper>
            );
        case 'Youtube':
            return (
                <Wrapper color={colored}>
                    <Youtube fill={colored} {...props} />
                </Wrapper>
            );
        case 'Whatsapp':
            return (
                <Wrapper color={colored}>
                    <Whatsapp fill={colored} {...props} />
                </Wrapper>
            );
        case 'Telegram':
            return (
                <Wrapper color={colored}>
                    <Telegram fill={colored} {...props} />
                </Wrapper>
            );
        case 'TikTok':
            return (
                <Wrapper color={colored}>
                    <TikTok fill={colored} {...props} />
                </Wrapper>
            );
        case 'Linkedin':
            return (
                <Wrapper color={colored}>
                    <Linkedin fill={colored} {...props} />
                </Wrapper>
            );
        case 'Email':
            return (
                <Wrapper color={colored}>
                    <Email fill={colored} {...props} />
                </Wrapper>
            );
        case 'ChevronRight':
            return <ChevronRight stroke={colored} {...props} />;
        case 'Play':
            return (
                <Wrapper color={colored}>
                    <Play fill={colored} {...props} />
                </Wrapper>
            );
        case 'Pause':
            return (
                <Wrapper color={colored}>
                    <Pause fill={colored} {...props} />
                </Wrapper>
            );
        case 'Replay':
            return (
                <Wrapper color={colored}>
                    <Replay fill={colored} {...props} />
                </Wrapper>
            );
        case 'Warning':
            return (
                <Wrapper color={colored}>
                    <Warning fill={colored} {...props} />
                </Wrapper>
            );
        case 'CreditCard':
            return (
                <Wrapper>
                    <CreditCard {...props} />
                </Wrapper>
            );
        case 'Pix':
            return (
                <Wrapper>
                    <Pix {...props} />
                </Wrapper>
            );
        case 'InfoTooltip':
            return (
                <Wrapper>
                    <InfoTooltip {...props} />
                </Wrapper>
            );
        default:
            return null;
    }
};

export const IconRounded = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    ${props => css`
        width: ${props.size}px;
        height: ${props.size}px;
        background-color: ${props.color};
    `}
`;

const Wrapper = styled.div`
    display: flex;
    align-items: center;

    path {
        fill: ${props => props.color};
    }
`;

export default Icon;
